import React from 'react';
import * as PropTypes from 'prop-types';
import {BasicNumberInput} from './basic-number-input';
import {convertIntoHexValue} from './input-logic';

export const HexColorInput = ({
	value,
	placeholder,
	disabled,
	hasError,
	onClick,
	onBlur,
	onChange,
	callback,
	modalView,
	width,
	alignLeft,
	cy,
}) => {
	return (
		<BasicNumberInput
			placeholder={placeholder}
			value={value}
			hasError={hasError}
			onClick={onClick}
			onBlur={onBlur}
			onChange={onChange}
			disabled={disabled}
			converterValue={value => convertIntoHexValue(value)}
			callback={callback}
			width={width}
			cy={cy}
			modalView={modalView}
			alignLeft={alignLeft}
		></BasicNumberInput>
	);
};

HexColorInput.propTypes = {
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blue the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	callback: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.string,
	/**
	 * This is necessary to get the value of the input from the parent
	 */
	onChange: PropTypes.func,

	/**
	 * Same a the callback prop but only called when typing Enter
	 */
	callbackOnEnter: PropTypes.func,

	/**
	 * Specific styling for the scheduling modals
	 */
	modalView: PropTypes.bool,

	/**
	 * Width of the input
	 */
	width: PropTypes.string,
	cy: PropTypes.string,
	alignLeft: PropTypes.bool,
};

HexColorInput.defaultProps = {
	disabled: false,
	hasError: false,
};
